<template>
  <div class="china_drug">
    <div>
      <ul class="color_333 pr15">
       <li v-for="(item, index) in drugList" :key="index" class="flex space-between pt10">
         <span class="width1 ellipsis">{{index+1}}. {{item.ypmc||item.drugName}}</span>
         <span class="width2 pl15 color_main3">
           ￥{{item.drugUnitPrice/100||item.price/100}} X {{item.ypsl||item.dosage}}{{item.jldw||item.dosageUnit}}
         </span>
         <span class="width3 left pl15">{{item.admission|filter_jianfu}}</span>
       </li>
     </ul>
    </div>
  </div>
</template>

<script>
    export default {
      name: "renewal-drugs-china-drug",
      props:{
        drugList: Array,
      },
      filters:{
        filter_jianfu(str){
          if (!str) return ''
          if (str === '煎服'){
            return ''
          } else {
            return str
          }
        }
      },
      computed: {
        left() {
          let list = []
          for(let i=0; i<this.drugList.length; i++ ){
            if (i%2 !==1) {
              let info = this.drugList[i]
              list.push(info)
            }
          }
          return list
        },
        right() {
          let list = []
          for(let i=0; i<this.drugList.length; i++ ){
            if (i%2 ===1) {
              let info = this.drugList[i]
              list.push(info)
            }
          }
          return list
        }
      }
    }
</script>
<style lang="scss">
  .china_drug{
    .width1{
      width: 40vw;
    }
    .width2{
      width: 30vw;
    }
    .width3{
      width: 50vw;
    }
  }
  .dash {
    border-top: 1px dashed #f1f1f1;
    height: 7px;
  }
</style>
